import fontawesome from '@fortawesome/fontawesome';

import faAlignJustify from '@fortawesome/fontawesome-free-solid/faAlignJustify';
import faAngleDown from '@fortawesome/fontawesome-free-solid/faAngleDown';
import faAngleRight from '@fortawesome/fontawesome-free-solid/faAngleRight';
import faAndroid from '@fortawesome/fontawesome-free-brands/faAndroid';
import faApple from '@fortawesome/fontawesome-free-brands/faApple';
import faArrowLeft from '@fortawesome/fontawesome-free-solid/faArrowLeft';
import faArrowRight from '@fortawesome/fontawesome-free-solid/faArrowRight';
import faAt from "@fortawesome/fontawesome-free-solid/faAt";

import faBars from '@fortawesome/fontawesome-free-solid/faBars';
import faBasketballBall from '@fortawesome/fontawesome-free-solid/faBasketballBall';

import faCalendar from '@fortawesome/fontawesome-free-solid/faCalendar';
import faCheckSquare from '@fortawesome/fontawesome-free-solid/faCheckSquare';
import faChessPawn from '@fortawesome/fontawesome-free-solid/faChessPawn';
import faCircle from '@fortawesome/fontawesome-free-solid/faCircle';
import faCircleNotch from '@fortawesome/fontawesome-free-solid/faCircleNotch';
import faCog from '@fortawesome/fontawesome-free-solid/faCog';
import faCoins from '@fortawesome/fontawesome-free-solid/faCoins';
import faCommentDots from '@fortawesome/fontawesome-free-regular/faCommentDots';
import faCreditCard from '@fortawesome/fontawesome-free-regular/faCreditCard';
import faCrown from '@fortawesome/fontawesome-free-solid/faCrown';

import faDice from '@fortawesome/fontawesome-free-solid/faDice';
import faDiceSix from '@fortawesome/fontawesome-free-solid/faDiceSix';
import faDollarSign from '@fortawesome/fontawesome-free-solid/faDollarSign';

import faEnvelope from '@fortawesome/fontawesome-free-regular/faEnvelope';
import faEquals from '@fortawesome/fontawesome-free-solid/faEquals';
import faExchangeAlt from '@fortawesome/fontawesome-free-solid/faExchangeAlt';
import faExpandArrowsAlt from '@fortawesome/fontawesome-free-solid/faExpandArrowsAlt';
import faExternalLinkAlt from '@fortawesome/fontawesome-free-solid/faExternalLinkAlt';
import faEye from '@fortawesome/fontawesome-free-regular/faEye';
import faEyeSlash from '@fortawesome/fontawesome-free-regular/faEyeSlash';

import faFire from '@fortawesome/fontawesome-free-solid/faFire';
import faFootballBall from '@fortawesome/fontawesome-free-solid/faFootballBall';
import faFutbol from '@fortawesome/fontawesome-free-solid/faFutbol';

import faGamepad from '@fortawesome/fontawesome-free-solid/faGamepad';
import faGem from '@fortawesome/fontawesome-free-regular/faGem';
import faGemSolid from '@fortawesome/fontawesome-free-solid/faGem';
import faGlobe from '@fortawesome/fontawesome-free-solid/faGlobe';

import faHistory from '@fortawesome/fontawesome-free-solid/faHistory';
import faHockeyPuck from '@fortawesome/fontawesome-free-solid/faHockeyPuck';

import faInstagram from '@fortawesome/fontawesome-free-brands/faInstagram';

import faLock from '@fortawesome/fontawesome-free-solid/faLock';

import faMinus from '@fortawesome/fontawesome-free-solid/faMinus';
import faMoneyBillAlt from '@fortawesome/fontawesome-free-solid/faMoneyBillAlt';
import faMoneyCheckAlt from '@fortawesome/fontawesome-free-solid/faMoneyCheckAlt';

import faPhone from '@fortawesome/fontawesome-free-solid/faPhone';
import faPhoneSquare from '@fortawesome/fontawesome-free-solid/faPhoneSquare';
import faPlayCircle from '@fortawesome/fontawesome-free-solid/faPlayCircle';
import faPlus from '@fortawesome/fontawesome-free-solid/faPlus';
import faPlusSquare from '@fortawesome/fontawesome-free-regular/faPlusSquare';

import faQuestion from '@fortawesome/fontawesome-free-solid/faQuestion';
import faQuestionCircle from '@fortawesome/fontawesome-free-solid/faQuestionCircle';

import faSearch from '@fortawesome/fontawesome-free-solid/faSearch';
import faSignal from '@fortawesome/fontawesome-free-solid/faSignal';
import faSignInAlt from '@fortawesome/fontawesome-free-solid/faSignInAlt';
import faSignOutAlt from '@fortawesome/fontawesome-free-solid/faSignOutAlt';
import faSkype from '@fortawesome/fontawesome-free-brands/faSkype';
import faSmile from '@fortawesome/fontawesome-free-solid/faSmile';
import faStar from '@fortawesome/fontawesome-free-solid/faStar';

import faTableTennis from '@fortawesome/fontawesome-free-solid/faTableTennis';
import faTelegram from '@fortawesome/fontawesome-free-brands/faTelegram';
import faTelegramPlane from '@fortawesome/fontawesome-free-brands/faTelegramPlane';
import faThumbsUp from '@fortawesome/fontawesome-free-regular/faThumbsUp';
import faTicketAlt from '@fortawesome/fontawesome-free-solid/faTicketAlt';
import faTimes from '@fortawesome/fontawesome-free-solid/faTimes';
import faTimesCircle from '@fortawesome/fontawesome-free-regular/faTimesCircle';
import faTrophy from '@fortawesome/fontawesome-free-solid/faTrophy';
import faTwitter from '@fortawesome/fontawesome-free-brands/faTwitter';
import faFacebook from '@fortawesome/fontawesome-free-brands/faFacebook';

import faUnlockAlt from '@fortawesome/fontawesome-free-solid/faUnlockAlt';
import faUser from '@fortawesome/fontawesome-free-solid/faUser';
import faUserCircle from '@fortawesome/fontawesome-free-regular/faUserCircle';

import faVideo from '@fortawesome/fontawesome-free-solid/faVideo';
import faVk from '@fortawesome/fontawesome-free-brands/faVk';
import faVolleyballBall from '@fortawesome/fontawesome-free-solid/faVolleyballBall';

import faWhatsapp from '@fortawesome/fontawesome-free-brands/faWhatsapp';

fontawesome.library.add(faAlignJustify);
fontawesome.library.add(faAngleDown);
fontawesome.library.add(faAngleRight);
fontawesome.library.add(faAndroid);
fontawesome.library.add(faApple);
fontawesome.library.add(faArrowLeft);
fontawesome.library.add(faArrowRight);
fontawesome.library.add(faAt);
fontawesome.library.add(faBars);
fontawesome.library.add(faBasketballBall);
fontawesome.library.add(faCalendar);
fontawesome.library.add(faCheckSquare);
fontawesome.library.add(faChessPawn);
fontawesome.library.add(faCircle);
fontawesome.library.add(faCircleNotch);
fontawesome.library.add(faCog);
fontawesome.library.add(faCoins);
fontawesome.library.add(faCommentDots);
fontawesome.library.add(faCreditCard);
fontawesome.library.add(faCrown);
fontawesome.library.add(faDice);
fontawesome.library.add(faDiceSix);
fontawesome.library.add(faDollarSign);
fontawesome.library.add(faEquals);
fontawesome.library.add(faEnvelope);
fontawesome.library.add(faExchangeAlt);
fontawesome.library.add(faExpandArrowsAlt);
fontawesome.library.add(faExternalLinkAlt);
fontawesome.library.add(faEye);
fontawesome.library.add(faEyeSlash);
fontawesome.library.add(faFire);
fontawesome.library.add(faFootballBall);
fontawesome.library.add(faFutbol);
fontawesome.library.add(faGamepad);
fontawesome.library.add(faGem);
fontawesome.library.add(faGemSolid);
fontawesome.library.add(faGlobe);
fontawesome.library.add(faHistory);
fontawesome.library.add(faHockeyPuck);
fontawesome.library.add(faInstagram);
fontawesome.library.add(faLock);
fontawesome.library.add(faMinus);
fontawesome.library.add(faMoneyBillAlt);
fontawesome.library.add(faMoneyCheckAlt);
fontawesome.library.add(faPhone);
fontawesome.library.add(faPhoneSquare);
fontawesome.library.add(faPlayCircle);
fontawesome.library.add(faPlus);
fontawesome.library.add(faPlusSquare);
fontawesome.library.add(faQuestion);
fontawesome.library.add(faQuestionCircle);
fontawesome.library.add(faSearch);
fontawesome.library.add(faSkype);
fontawesome.library.add(faSignal);
fontawesome.library.add(faSignInAlt);
fontawesome.library.add(faSignOutAlt);
fontawesome.library.add(faSmile);
fontawesome.library.add(faStar);
fontawesome.library.add(faTableTennis);
fontawesome.library.add(faTelegram);
fontawesome.library.add(faTelegramPlane);
fontawesome.library.add(faThumbsUp);
fontawesome.library.add(faTicketAlt);
fontawesome.library.add(faTimes);
fontawesome.library.add(faTimesCircle);
fontawesome.library.add(faTrophy);
fontawesome.library.add(faTwitter);
fontawesome.library.add(faFacebook);
fontawesome.library.add(faUnlockAlt);
fontawesome.library.add(faUser);
fontawesome.library.add(faUserCircle);
fontawesome.library.add(faVideo);
fontawesome.library.add(faVk);
fontawesome.library.add(faVolleyballBall);
fontawesome.library.add(faWhatsapp);



// WEBPACK FOOTER //
// ./_common/fa.js